import actions from "@/store/modules/gross-inventory/actions";
import mutations from "@/store/modules/gross-inventory/mutations";
import state from "@/store/modules/gross-inventory/state";

export default {
    actions,
    mutations,
    state
}
